module.exports = __webpack_public_path__ + "img/quali-banner-1440.e516b7c3.jpg";